export default Object.freeze({
  USER: "USER",
  MAIN_ASSISTED: "MAIN_ASSISTED",
  ADITIONAL_ASSISTED: "ADITIONAL_ASSISTED",
});
